import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import { mapExperienceToBookingView } from 'lib/experiences/experienceUtils'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import ExperiencePartnershipLabel from 'components/Common/Vendors/Partnership/ExperiencePartnershipLabel'
import StatusLabel from 'components/Luxkit/Label/StatusLabel'
import ImageCarousel from 'components/Luxkit/Carousel/ImageCarousel'
import config from 'constants/config'
import Image from 'components/Common/Image'

const Root = styled.div`
  display: flex;
  position: relative;
`

const BadgeContainer = styled.div`
  position: absolute;
  top: ${rem(12)};
  left: ${rem(12)};
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > * + * {
    margin-top: ${rem(8)};
  }
`

const RightSideBadge = styled.div`
  position: absolute;
  top: ${rem(12)};
  right: ${rem(12)};
`

interface Props {
  experience: App.ExperienceOffer;
  partnershipBadge?: boolean;
  addedBadge?: boolean;
}

function ExperienceImageCarousel(props: Props) {
  const {
    experience,
    partnershipBadge,
    addedBadge,
  } = props

  const viewExp = useMemo(
    () => mapExperienceToBookingView(experience),
    [experience],
  )

  return (
    <Root>
      <ImageCarousel
        images={experience.images}
      />
      <BadgeContainer>
        {addedBadge && <StatusLabel variant="added" startIcon={<LineCheckIcon />}>Added</StatusLabel>}
        {viewExp.leExclusive && <ProductTypeLabel productType={viewExp.type} />}
        {partnershipBadge && <ExperiencePartnershipLabel price={experience.price} type={experience.productType} variant="icon" />}
      </BadgeContainer>
      {config.EXPERIENCE_BADGE_IMAGE_ID && <RightSideBadge>
        <Image id={config.EXPERIENCE_BADGE_IMAGE_ID} height={80} width={80} />
      </RightSideBadge>}
    </Root>
  )
}

export default ExperienceImageCarousel
